module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bf3ee9d7d91a231cde773f88f6799425.png";